import type { HTMLAttributes, ReactElement } from "react";
import cx from "ui/cx";
import styles from "./LoadingHigharcIcon.module.scss";

export interface LoadingHigharcIconProps extends HTMLAttributes<HTMLDivElement> {
  readonly size?: number;
}

export default function LoadingHigharcIcon({ className, size = 20, ...props }: LoadingHigharcIconProps): ReactElement {
  return (
    <div
      role="status"
      aria-busy
      aria-label={props["aria-label"] ?? "Loading"}
      {...props}
      className={cx(styles.iconWrapper, className)}
    >
      <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <rect width="20" height="20" rx="2" className={styles.iconBackground} />
        <g className={styles.arcContainer}>
          <path d="M 2 10 A 8 8 0 0 1 18 10 Z" className={styles.iconArc} />
        </g>
      </svg>
    </div>
  );
}
